import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../config';

type InitApiService = (axiosInstance: AxiosInstance, baseUrl: string | false) => void;

const initKycMFEApiService = async () => {
  try {
    const initKYCMFEApiServiceModule = await loadRemoteModule<{
      default: InitApiService;
      initSmApiService: InitApiService;
      initKnowYourCustomerApiService: InitApiService;
    }>('kyc/initKYCMFEApiService');
    const initKYCMFEApiService = initKYCMFEApiServiceModule.default;
    const { initSmApiService, initKnowYourCustomerApiService } = initKYCMFEApiServiceModule;
    const basePath = Config.CURRENT_ORIGINS.KYC.replace('/api', '');
    initKYCMFEApiService?.(RedisApiAxiosInstance, basePath);
    initSmApiService?.(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
    initKnowYourCustomerApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.API_ENV
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initKycMFEApiService', e);
  }
};

export default initKycMFEApiService;
